import {
  cleanAutocompleteText,
  dedupeAutocompleteStrings,
} from "./autocompleteOptions";

export const COMPANY_SIZE_OPTIONS = [
  "1 - 10 employees",
  "11 - 50 employees",
  "50 - 200 employees",
  "201 - 500 employees",
  "501 - 1,000 employees",
  "1,001 - 5,000 employees",
  "5,000+ employees",
];

const COMPANY_SIZE_NORMALIZERS = [
  [/^1\s*-\s*10(?:\s*employees?)?$/i, "1 - 10 employees"],
  [/^11\s*-\s*50(?:\s*employees?)?$/i, "11 - 50 employees"],
  [/^50\s*-\s*200(?:\s*employees?)?$/i, "50 - 200 employees"],
  [/^201\s*-\s*500(?:\s*employees?)?$/i, "201 - 500 employees"],
  [/^501\s*-\s*1,?000(?:\s*employees?)?$/i, "501 - 1,000 employees"],
  [/^1,?001\s*-\s*5,?000(?:\s*employees?)?$/i, "1,001 - 5,000 employees"],
  [/^5,?000\+\s*(?:employees?)?$/i, "5,000+ employees"],
];

export function normalizeCompanySizeValue(value = "") {
  const cleanedValue = cleanAutocompleteText(value).replace(/[–—]/g, "-");
  if (!cleanedValue) return "";

  for (const [pattern, normalized] of COMPANY_SIZE_NORMALIZERS) {
    if (pattern.test(cleanedValue)) {
      return normalized;
    }
  }

  return cleanedValue;
}

export function buildCompanySizeOptions(values = []) {
  return dedupeAutocompleteStrings([
    ...COMPANY_SIZE_OPTIONS,
    ...(Array.isArray(values) ? values : [values]).map((value) =>
      normalizeCompanySizeValue(value)
    ),
  ]);
}
